import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

// Import pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceArea from "./pages/ServiceArea";
import InspectionsForBuyers from "./pages/InspectionsForBuyers";
import InspectionsForSellers from "./pages/InspectionsForSellers";
import About from "./pages/About";
import Blog from "./pages/Blog";
import ArticlePage from "./pages/blog/ArticlePage";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Team from "./pages/Team";
import Privacy from "./pages/Privacy";
import Pricing from "./pages/Pricing";
import SampleReports from "./pages/SampleReports";
import Partners from "./pages/Partners";
import AdminBlog from "./pages/admin/AdminBlog";
import NotFound from "./pages/NotFound";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="services/:serviceId" element={<Services />} />
            <Route path="service-areas/:regionId" element={<ServiceArea />} />
            <Route path="inspections-for-buyers" element={<InspectionsForBuyers />} />
            <Route path="inspections-for-sellers" element={<InspectionsForSellers />} />
            <Route path="about" element={<About />} />
            <Route path="team" element={<Team />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<ArticlePage />} />
            <Route path="contact" element={<Contact />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="sample-reports" element={<SampleReports />} />
            <Route path="partners" element={<Partners />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<AdminBlog />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;